import Swal from "sweetalert2";

/**
 * Error de acción del usuario (like, tweet, reply, delete, upload...).
 * Muestra un modal conciso. Úsalo cuando el usuario hizo algo y falló.
 */
export function notifyError(message = "Ocurrió un error. Intenta de nuevo.") {
  Swal.fire({
    icon: "error",
    title: "Algo salió mal",
    text: message,
    confirmButtonColor: "#3b82f6",
    timer: 5000,
    timerProgressBar: true,
  });
}

/**
 * Error de carga de datos (no se pudo obtener algo de Firestore).
 * Usa un toast no invasivo en la esquina — no interrumpe el flujo.
 */
export function notifyLoadError(message = "No se pudieron cargar los datos.") {
  Swal.fire({
    icon: "warning",
    toast: true,
    position: "bottom-end",
    showConfirmButton: false,
    timer: 3500,
    timerProgressBar: true,
    title: message,
  });
}
